import { ServiceWorkerState } from './types';

export const serviceWorkerInitialState: ServiceWorkerState = {
  waitingServiceWorker: null,
};
